import useMutationHookWrapper, {TAsyncStatesHandlers} from "../../../../../../../hooks/use-mutation-hook-wrapper";
import {network} from "../../../../../../../types";
import {servicesUsers} from "../../../../../../../services";

const useRevalidateCftPost = (
  arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
  return useMutationHookWrapper<
    network.TQueryDefWrapper<null>,
    string,
    { id: string }
  >({
    mutationFn: servicesUsers.revalidateCft,
    mutationConfig: {},
    asyncStateHandlers: arg0,
  });
};

export default useRevalidateCftPost;
